import { isProductAssetType } from "@hightouch/lib/agents/asset-base-types";
import { PageSpinner } from "src/components/loading";
import { useCatalogProductQuery } from "src/graphql";
import { useAssetCollections } from "src/pages/agents/hooks/use-asset-collections";
import { ASSET_LIBRARY_PATH } from "src/pages/context-hub/assets-paths";
import { Navigate, useParams } from "src/router";

/** Sends the retired catalog list to the first product catalog in the library. */
export const CatalogIndexRedirect = () => {
  const { collections, isLoading } = useAssetCollections({ suspense: false });

  if (isLoading) {
    return <PageSpinner />;
  }

  const catalog = collections.find(isProductAssetType);
  return (
    <Navigate
      to={catalog ? `${ASSET_LIBRARY_PATH}/${catalog.id}` : ASSET_LIBRARY_PATH}
      replace
    />
  );
};

/**
 * Opens a product in the catalog that holds it. Agent-written briefs and
 * plans link products by id alone.
 */
export const CatalogProductRedirect = () => {
  const { catalogItemId = "" } = useParams<{ catalogItemId: string }>();
  const { data, isLoading } = useCatalogProductQuery(
    { id: catalogItemId },
    { enabled: Boolean(catalogItemId) },
  );

  if (isLoading) {
    return <PageSpinner />;
  }

  // An unknown product still opens its dialog, which reports the failure.
  const assetGroupId = data?.catalogProduct?.assetGroupId;
  const params = new URLSearchParams({ asset: catalogItemId });
  return (
    <Navigate
      to={`${ASSET_LIBRARY_PATH}${assetGroupId ? `/${assetGroupId}` : ""}?${params}`}
      replace
    />
  );
};
